import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import './ManagePayments.css';

function ManagePayments() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState({});
  const [notification, setNotification] = useState(null);
  const timerRef = useRef(null);

  // Fetch all pending withdrawals
  const fetchWithdrawals = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const token = await user.getIdToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/withdrawals/pending`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setWithdrawals(response.data);
    } catch (err) {
      console.error('Error fetching withdrawals:', err);
      setNotification('Failed to load withdrawals');
      timerRef.current = setTimeout(() => setNotification(null), 5000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawals();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  // Handle marking a withdrawal as complete
  const handleComplete = async (withdrawalId) => {
    try {
      setSending(prev => ({ ...prev, [withdrawalId]: true }));
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const token = await user.getIdToken();

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/withdrawals/complete`,
        { withdrawalId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setNotification(response.data.message || 'Withdrawal marked complete');
      fetchWithdrawals();
    } catch (err) {
      console.error('Error completing withdrawal:', err);
      setNotification(err.response?.data?.error || 'Failed to complete withdrawal');
    } finally {
      timerRef.current = setTimeout(() => setNotification(null), 5000);
      setSending(prev => ({ ...prev, [withdrawalId]: false }));
    }
  };

  return (
    <div className="manage-payments">
      <h2>Manage Payments</h2>
      {notification && <div className="notification">{notification}</div>}
      {loading ? (
        <p>Loading withdrawals...</p>
      ) : withdrawals.length === 0 ? (
        <p>No pending withdrawals.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Amount</th>
              <th>Bank Info</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map((w) => (
              <tr key={w.id}>
                <td>{w.username}</td>
                <td>{w.email}</td>
                <td>{w.pointsRequested}</td>
                <td>
                  {w.accountHolder} / {w.accountNumber} / {w.branchCode} / {w.accountType}
                </td>
                <td>
                  <button
                    onClick={() => handleComplete(w.id)}
                    disabled={sending[w.id]}
                  >
                    {sending[w.id] ? 'Processing...' : 'Complete'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ManagePayments;
